import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDate, limitParagraphByCharLimit } from "../../Helper/Helper";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import Spinner from "../Spinner";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function ListViewBlogsGrid() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("blogs/list");
      setBlogsData(response?.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Blogs" Image="theme-2-banner-blog.webp"/>

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <Spinner />
          </div>
        ) : blogsData?.length > 0 ? (
          <section className="blog-section pad-top-80 pad-bottom-80 full-dark">
            <div className="container">
              <div className="row">
                {blogsData?.map((data, index) => (
                  <div className="col-lg-12 mb-5" key={index}>
                    <div className="blog-main-wrap blog-list-style-1">
                      <div className="blog-inner h-100">
                        <div className="media h-100">
                          <div className="blog-thumb relative">
                            {/* <img
                              src={data?.image}
                              style={{
                                width: "460px",
                                height: "230px"
                              }}
                              className="img-fluid"
                              alt="blog-img"
                            /> */}

                            <div
                              style={{
                                width: "460px",
                                height: "230px",
                                backgroundImage: `url(${data?.image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "top center",
                                backgroundRepeat: "no-repeat",
                              }}
                              className="img-fluid"
                            ></div>

                            <div className="blog-overlay">
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="post-link"
                              >
                                <span className="icon-link icons"></span>
                              </Link>
                            </div>
                          </div>
                          <div className="media-body align-self-center">
                            <div className="blog-list-details">
                              <div className="blog-title">
                                <h3 className="entry-title mb-2">
                                  <Link
                                    to={`/blog/detail/${data?.slug}`}
                                    className="blog-name"
                                    style={{ fontSize: "18px" }}
                                  >
                                    {data?.title}
                                  </Link>
                                </h3>
                              </div>
                              <div className="post-desc pb-1">
                                <p>
                                  {limitParagraphByCharLimit(
                                    data?.short_content || data?.content,
                                    350
                                  )}
                                  {(data?.short_content || data?.content)?.length > 350 ? "..." : ""}

                                </p>
                              </div>
                              <div className="post-meta">
                                <div className="blog-link list-view-blog-readmore">
                                  <Link
                                    to={`/blog/detail/${data?.slug}`}
                                    className="link"
                                  >
                                    Read More
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* {index < blogsData.length - 1 && <hr className="black" />} */}
                    <hr className="black" />
                  </div>
                ))}
              </div>
            </div>
          </section>
        ) : (
          <div className="col-12 text-center my-5 py-5">
            <h4>No Record Available</h4>
          </div>
        )}

        <FooterWrapper />
      </div>
    </div>
  );
}

export default ListViewBlogsGrid;